import * as React from 'react';

import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as RequirementsStore from '../../store/requirements';
import { ValidateRequirement } from '../../components/requirements/ValidateRequirement';

export default connect(
    (state: ApplicationState) => ({
        ...state.identity,
        ...state.user,
        ...state.constants,
        ...RequirementsStore.plainActions,
        moduleManager: state.modules.moduleManager,
        user: state.identity?.user,
        workId: state.work.work?.id,
    }),
    {},
)(ValidateRequirement as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
